import React, { Component } from "react";
import cn from "classnames";
import Modal from "react-modal";
import { Divider } from "shared/layout";
import Overlay from "shared/components/Overlay";
import config from "../../config";
import Link from "../Link";
import LinkIcon from "../LinkIcon";
import Submenu from "../Submenu";
import UserHeader from "../UserHeader";
import UserMenu from "../UserMenu";
import styles from "./styles.css";

class NavModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedId: "",
      isVisible: false,
      offsetTop: 0,
    };
  }

  componentDidMount() {
    this.headerNode = null;

    if (typeof document !== "undefined") {
      this.headerNode = document.getElementById("global-header");
    }

    if (this.headerNode) {
      Modal.setAppElement(this.headerNode);
    }
  }

  getOffsetTop = () => {
    let offsetTop = 0;

    if (this.headerNode) {
      offsetTop = this.headerNode.getBoundingClientRect().top;
    }

    return offsetTop;
  };

  show = () => {
    this.setState({
      isVisible: true,
      offsetTop: this.getOffsetTop(),
    });
  };

  hide = () => {
    const { onRequestClose } = this.props;

    this.setState({ isVisible: false }, onRequestClose);
  };

  toggleMenu = (event) => {
    const { expandedId } = this.state;
    const targetId = event.currentTarget.getAttribute("aria-controls");

    event.preventDefault();

    this.setState({
      expandedId: targetId === expandedId ? "" : targetId,
    });
  };

  render() {
    const { isOpen } = this.props;
    const { expandedId, isVisible, offsetTop } = this.state;
    const navigationItems = config.baseMenu.items
      .filter(item => item.title !== "Search")
      .sort((a, b) => a.mobileOrder - b.mobileOrder);

    return (
      <Modal
        isOpen={isOpen}
        overlayClassName={styles.modalOverlay}
        style={{ overlay: { top: `${offsetTop}px` } }}
        className={cn({
          [styles.wrapper]: true,
          [styles.isVisible]: isVisible,
        })}
        shouldCloseOnOverlayClick={false}
        onRequestClose={this.hide}
        onAfterOpen={this.show}
        closeTimeoutMS={200}
      >
        <Overlay
          className={styles.overlay}
          onClick={this.hide}
          style={{ top: `${offsetTop}px` }}
        />

        <nav
          className={styles.navigation}
          role="navigation"
        >
          <UserHeader />

          <ul>
            {navigationItems.map((item) => {
              const id = `${item.title.toLowerCase()}-menu-mobile`;
              const label = `${item.title.toLowerCase()}-heading-mobile`;

              return (
                <li key={item.title} className={styles.item}>
                  {!item.submenu && <Link href={item.url}>{item.title}</Link>}

                  {item.submenu && (
                    <Link
                      href={item.url}
                      onClick={this.toggleMenu}
                      aria-controls={id}
                      id={label}
                    >
                      {item.title}

                      <LinkIcon expanded={id === expandedId} />
                    </Link>
                  )}

                  {item.submenu &&
                    item.submenu.items.length > 0 && (
                      <Submenu
                        id={id}
                        hidden={id !== expandedId}
                        aria-expanded={id === expandedId}
                        items={item.submenu.items}
                        featured={item.submenu.featured}
                        aria-labelledby={label}
                      />
                    )}
                </li>
              );
            })}
          </ul>

          <Divider className={styles.divider} />

          <UserMenu />
        </nav>
      </Modal>
    );
  }
}

export default NavModal;
